import { useState } from 'react';
import { ConversationFeedContext } from '../../contexts/CommunicationNavigationContext';
import { useProConversations, type ProConversationFeed } from '../../hooks/useProConversations';
import CommunicationDrawer from './CommunicationDrawer';
export default function CommunicationQueue({ pro, feed }: { pro: string; feed?: ProConversationFeed }) {
  const ownFeed = useProConversations(pro, !feed);
  const currentFeed = feed ?? ownFeed;
  const { rows, error, loading } = currentFeed;
  const [selected, setSelected] = useState<string>();
  return <div className="space-y-2">
    {loading && <p role="status" className="text-sm text-muted">Loading communications…</p>}
    {error && <p role="alert" className="text-sm text-red-600">{error}</p>}
    {rows.filter(row => row.pro === pro).map(row => <button type="button" key={row.conversation_id} className="block w-full rounded border border-theme-border-primary p-3 text-left hover:bg-blue-50 dark:hover:bg-gray-800" onClick={() => setSelected(row.conversation_id)}>
      <span className="text-sm font-semibold text-blue-600 dark:text-blue-400">Communication Request{row.unread ? ' · New' : ''}</span>
      <span className="ml-2 text-xs text-muted">{row.status === 'OPEN' ? 'Open' : 'Resolved'}</span>
      <span className="block text-xs text-muted">{row.sender_name} → {row.recipient_name}</span>
      <span className="block whitespace-pre-wrap break-words text-sm text-body">{row.preview}</span>
    </button>)}
    {selected && <ConversationFeedContext.Provider value={currentFeed}><CommunicationDrawer key={selected} pro={pro} conversationId={selected} onClose={() => setSelected(undefined)} /></ConversationFeedContext.Provider>}
  </div>;
}
